import Client from "../client/ApiClient"

const ees = {
  // Auth
  login: (data) => Client.post("auth/login/", data),
  logout: (body) => Client.post("auth/logout/", body),
  me: () => Client.get("auth/me/"),

  // Projects
  projects: () => Client.get("projects/"),
  projectsMap: () => Client.get("projects/map/"),
  project: (id) => Client.get(`projects/${id}/`),
  createProject: (body) => Client.post("projects/", body),
  patchProject: (id, body) => Client.patch(`projects/${id}/`, body),
  deleteProject: (id) => Client.delete(`projects/${id}/`),
  designProfile: (id) => Client.get(`projects/${id}/design-profile/`),
  getPumpFlowConfig: (id) => Client.get(`projects/${id}/pump-flow/`),
  putPumpFlowConfig: (id, body) => Client.put(`projects/${id}/pump-flow/`, body),
  members: (id) => Client.get(`projects/${id}/members/`),
  addMember: (id, body) => Client.post(`projects/${id}/members/`, body),
  removeMember: (id, membershipId) => Client.delete(`projects/${id}/members/${membershipId}/`),
  assignMemberRole: (pid, membershipId, body) =>
    Client.post(`projects/${pid}/members/${membershipId}/roles/`, body),
  revokeMemberRole: (pid, membershipId, assignmentId) =>
    Client.delete(`projects/${pid}/members/${membershipId}/roles/`, {
      params: { assignment_id: assignmentId }
    }),
  tanks: (id) => Client.get(`projects/${id}/tanks/`),
  createTank: (pid, body) => Client.post(`projects/${pid}/tanks/`, body),
  patchTank: (pid, tankId, body) => Client.patch(`projects/${pid}/tanks/${tankId}/`, body),
  deleteTank: (pid, tankId) => Client.delete(`projects/${pid}/tanks/${tankId}/`),

  // Catalogs
  parameters: (params) => Client.get("catalogs/parameters/", { params }),
  createParameter: (body) => Client.post("catalogs/parameters/", body),
  patchParameter: (id, body) => Client.patch(`catalogs/parameters/${id}/`, body),
  incidentTypes: () => Client.get("catalogs/incident-types/"),
  createIncidentType: (body) => Client.post("catalogs/incident-types/", body),
  patchIncidentType: (id, body) => Client.patch(`catalogs/incident-types/${id}/`, body),
  equipmentModels: () => Client.get("catalogs/equipment-models/"),
  createEquipmentModel: (body) => Client.post("catalogs/equipment-models/", body),
  patchEquipmentModel: (id, body) => Client.patch(`catalogs/equipment-models/${id}/`, body),
  regulations: () => Client.get("regulations/"),
  regulation: (id) => Client.get(`regulations/${id}/`),
  createRegulation: (body) => Client.post("regulations/", body),
  patchRegulation: (id, body) => Client.patch(`regulations/${id}/`, body),
  deleteRegulation: (id) => Client.delete(`regulations/${id}/`),
  upsertRegulationParameter: (id, body) => Client.put(`regulations/${id}/parameter-limits/`, body),
  deleteRegulationParameter: (id, parameterId) =>
    Client.delete(`regulations/${id}/parameter-limits/`, { params: { parameter_id: parameterId } }),
  addRegulationColumn: (id, body) => Client.post(`regulations/${id}/columns/`, body),
  deleteRegulationColumn: (id, key) =>
    Client.delete(`regulations/${id}/columns/`, { params: { key } }),
  regulationMatrix: (params) => Client.get("regulations/matrix/", { params }),
  regulationProfileOptions: () => Client.get("regulations/profile-options/"),
  regulationVersions: (id) => Client.get(`regulations/${id}/versions/`),
  projectParameters: (pid) => Client.get(`projects/${pid}/parameters/`),
  upsertProjectParameter: (pid, body) => Client.post(`projects/${pid}/parameters/`, body),
  deleteProjectParameter: (pid, ppId) => Client.delete(`projects/${pid}/parameters/${ppId}/`),
  addProjectParameter: (pid, body) => Client.post(`projects/${pid}/parameters/`, body),
  complianceProfiles: (pid) => Client.get(`projects/${pid}/compliance-profile/`),
  createComplianceProfile: (pid, body) => Client.post(`projects/${pid}/compliance-profile/`, body),
  activateCompliance: (pid, body) => Client.post(`projects/${pid}/compliance-profile/activate/`, body),

  // Ops
  dailyLogs: (pid) => Client.get(`projects/${pid}/daily-logs/`),
  dailyLog: (pid, lid) => Client.get(`projects/${pid}/daily-logs/${lid}/`),
  createDailyLog: (pid, body) => Client.post(`projects/${pid}/daily-logs/`, body),
  patchDailyLog: (pid, lid, body) => Client.patch(`projects/${pid}/daily-logs/${lid}/`, body),
  completeDailyLog: (pid, lid) => Client.post(`projects/${pid}/daily-logs/${lid}/complete/`),
  meterReadings: (pid) => Client.get(`projects/${pid}/meter-readings/`),
  createMeter: (pid, body) => Client.post(`projects/${pid}/meter-readings/`, body),
  capacity: (pid, params) => Client.get(`projects/${pid}/capacity/`, { params }),
  projectDashboard: (pid) => Client.get(`projects/${pid}/dashboard/`),
  waterResults: (pid, params) => Client.get(`projects/${pid}/water-results/`, { params }),
  waterResult: (pid, rid) => Client.get(`projects/${pid}/water-results/${rid}/`),
  createWater: (pid, body) => Client.post(`projects/${pid}/water-results/`, body),
  submitWater: (pid, rid) => Client.post(`projects/${pid}/water-results/${rid}/submit/`),
  approveWater: (pid, rid) => Client.post(`projects/${pid}/water-results/${rid}/approve/`),
  rejectWater: (pid, rid, body) => Client.post(`projects/${pid}/water-results/${rid}/reject/`, body),
  adminAmendWater: (pid, rid, body) =>
    Client.post(`projects/${pid}/water-results/${rid}/admin-amend/`, body),

  // Chemicals (monthly balance)
  chemicalCatalog: () => Client.get("catalogs/chemicals/"),
  createChemicalCatalog: (body) => Client.post("catalogs/chemicals/", body),
  projectChemicals: (pid) => Client.get(`projects/${pid}/chemicals/`),
  addProjectChemical: (pid, body) => Client.post(`projects/${pid}/chemicals/`, body),
  chemicalBalances: (pid, year, month) =>
    Client.get(`projects/${pid}/chemical-balances/${year}/${month}/`),
  putChemicalBalances: (pid, year, month, body) =>
    Client.put(`projects/${pid}/chemical-balances/${year}/${month}/`, body),
  lockChemicalBalances: (pid, year, month) =>
    Client.post(`projects/${pid}/chemical-balances/${year}/${month}/lock/`),

  // Alerts
  alerts: (params) => Client.get("alerts/", { params }),
  unreadCount: () => Client.get("alerts/unread-count/"),
  readAlert: (id) => Client.post(`alerts/${id}/read/`),
  ackAlert: (id) => Client.post(`alerts/${id}/ack/`),
  remindAlerts: (body) => Client.post("alerts/remind/", body || {}),
  createAlert: (body) => Client.post("alerts/create/", body),

  // Incidents
  incidents: (params) => Client.get("incidents/", { params }),
  projectIncidents: (pid, params) => Client.get(`projects/${pid}/incidents/`, { params }),
  createIncident: (pid, body) => Client.post(`projects/${pid}/incidents/`, body),
  incident: (pid, iid) => Client.get(`projects/${pid}/incidents/${iid}/`),
  patchIncident: (pid, iid, body) => Client.patch(`projects/${pid}/incidents/${iid}/`, body),
  incidentAction: (pid, iid, action, body) =>
    Client.post(`projects/${pid}/incidents/${iid}/actions/${action}/`, body || {}),

  // Reports
  portfolio: () => Client.get("portfolio/summary/"),
  portfolioQuick: () => Client.get("portfolio/summary/", { params: { parts: "quick" } }),
  portfolioVolumes: () => Client.get("portfolio/summary/", { params: { parts: "volumes" } }),
  reportPreview: (pid, code, params) =>
    Client.get(`projects/${pid}/reports/${code}/preview/`, { params }),
  reportExportUrl: (pid, code, format = "xlsx", params = {}) => {
    const q = new URLSearchParams({ export_format: format, ...params })
    return `projects/${pid}/reports/${code}/export/?${q.toString()}`
  },
  snapshotExportUrl: (pid, sid, format = "xlsx") =>
    `projects/${pid}/reports/snapshots/${sid}/export/?export_format=${format}`,
  lockReport: (pid, code, body) => Client.post(`projects/${pid}/reports/${code}/lock/`, body),
  snapshots: (pid) => Client.get(`projects/${pid}/reports/snapshots/`),

  // Revenue R10
  pricingPortfolio: () => Client.get("pricing-portfolio/"),
  projectPricing: (pid) => Client.get(`projects/${pid}/pricing/`),
  putProjectPricing: (pid, body) => Client.put(`projects/${pid}/pricing/`, body),
  pricingVersions: (pid) => Client.get(`projects/${pid}/pricing/versions/`),
  publishPricing: (pid, body) => Client.post(`projects/${pid}/pricing/versions/`, body),
  inletMeterPreview: (pid, params) =>
    Client.get(`projects/${pid}/pricing/inlet-preview/`, { params }),
  revenuePeriods: (params) => Client.get("revenue-periods/", { params }),
  projectRevenuePeriods: (pid, params) =>
    Client.get(`projects/${pid}/revenue-periods/`, { params }),
  generateRevenuePeriod: (pid, body) => Client.post(`projects/${pid}/revenue-periods/`, body),
  revenuePeriod: (id) => Client.get(`revenue-periods/${id}/`),
  patchRevenuePeriod: (id, body) => Client.patch(`revenue-periods/${id}/`, body),
  revenuePeriodAction: (id, action) => Client.post(`revenue-periods/${id}/actions/${action}/`),
  revenueAdjustment: (id, body) => Client.post(`revenue-periods/${id}/adjustments/`, body),
  revenueExportUrl: (id) => `revenue-periods/${id}/export.pdf`,

  // RBAC
  users: () => Client.get("users/"),
  roles: () => Client.get("roles/"),
  permissions: () => Client.get("permissions/"),
  auditLogs: (params) => Client.get("audit-logs/", { params }),

  // AMM P0
  ammCatalog: (params) => Client.get("amm/catalog-items", { params }),
  ammCreateCatalog: (body) => Client.post("amm/catalog-items", body),
  ammPatchCatalog: (id, body) => Client.patch(`amm/catalog-items/${id}`, body),
  ammDeleteCatalog: (id) => Client.delete(`amm/catalog-items/${id}`),
  ammEquipment: (params) => Client.get("amm/equipment", { params }),
  patchAmmEquipment: (id, body) => Client.patch(`amm/equipment/${id}`, body),
  ammCompanyBalances: () => Client.get("amm/company-balances"),
  ammApprovers: () => Client.get("amm/settings/approvers"),
  ammSetApprovers: (body) => Client.put("amm/settings/approvers", body),
  ammIssueRequests: (params) => Client.get("amm/issue-requests", { params }),
  ammCreateIssueRequest: (body) => Client.post("amm/issue-requests", body),
  ammIssueAction: (id, action, body) => Client.post(`amm/issue-requests/${id}/${action}`, body || {}),
  ammStockIn: (body) => Client.post("amm/stock-documents/in", body),
  ammStockDocuments: (params) => Client.get("amm/stock-documents", { params }),
  ammStockDocument: (id) => Client.get(`amm/stock-documents/${id}`),
  ammOutB: (body) => Client.post("amm/stock-documents/out-b", body),
  ammOutBAction: (id, action, body) =>
    Client.post(`amm/stock-documents/out-b/${id}/${action}`, body || {}),
  ammReceive: (outId, body) => Client.post(`amm/stock-documents/out/${outId}/receive`, body || {}),
  ammCancelTransit: (outId, body) =>
    Client.post(`amm/stock-documents/out/${outId}/cancel-transit`, body || {}),
  ammConsume: (body) => Client.post("amm/stock-documents/consume", body),
  ammSkuStats: (pid) => Client.get(`amm/projects/${pid}/sku-stats`),
  ammProjectEquipment: (pid) => Client.get(`amm/projects/${pid}/equipment`),
  ammInTransit: (pid) => Client.get(`amm/projects/${pid}/in-transit`),
  ammInTransitAll: () => Client.get("amm/in-transit"),
  ammFlocs: (pid) => Client.get(`amm/projects/${pid}/flocs`),
  ammCreateFloc: (pid, body) => Client.post(`amm/projects/${pid}/flocs`, body),
  ammPatchFloc: (pid, flocId, body) => Client.patch(`amm/projects/${pid}/flocs/${flocId}`, body),
  ammEquipmentAction: (id, action, body) =>
    Client.post(`amm/equipment/${id}/actions/${action}`, body || {}),
  ammReturn: (body) => Client.post("amm/stock-documents/return", body),
  ammWorkOrders: (params) => Client.get("amm/work-orders", { params }),
  ammCreateWorkOrder: (body) => Client.post("amm/work-orders", body),
  ammPatchWorkOrder: (id, body) => Client.patch(`amm/work-orders/${id}`, body),
  ammMaintenanceEvents: (params) => Client.get("amm/maintenance-events", { params }),
  ammStocktakes: () => Client.get("amm/stocktakes"),
  ammCreateStocktake: (body) => Client.post("amm/stocktakes", body),
  ammStocktake: (id) => Client.get(`amm/stocktakes/${id}`),
  ammStocktakeAction: (id, action, body) =>
    Client.post(`amm/stocktakes/${id}/${action}`, body || {}),
  ammDashboard: () => Client.get("amm/dashboard"),
  ammAlerts: () => Client.get("amm/alerts"),
  ammEmitAlerts: () => Client.post("amm/alerts/emit", {}),
  ammReport: (name, params) => Client.get(`amm/reports/${name}`, { params }),

  // Telemetry (Máy B Timescale — đọc-only)
  telemetryHealth: () => Client.get("telemetry/health/"),
  telemetrySummary: () => Client.get("telemetry/summary/"),
  telemetryDashboard: (params) => Client.get("telemetry/dashboard/", { params }),
  telemetryLast: (params) => Client.get("telemetry/last/", { params }),
  telemetryHistory: (params) => Client.get("telemetry/history/", { params }),
  telemetryGatewayStatus: (params) => Client.get("telemetry/gateway-status/", { params }),
  telemetryEmitAlerts: () => Client.post("telemetry/alerts/emit/", {}),
  telemetryTags: (projectId, params) => Client.get("telemetry/tags/", { params: { project_id: projectId, ...(params || {}) } }),
  tagMappings: (pid, params) => Client.get(`projects/${pid}/tag-mappings/`, { params }),
  createTagMapping: (pid, body) => Client.post(`projects/${pid}/tag-mappings/`, body),
  patchTagMapping: (pid, mid, body) => Client.patch(`projects/${pid}/tag-mappings/${mid}/`, body),
  deleteTagMapping: (pid, mid) => Client.delete(`projects/${pid}/tag-mappings/${mid}/`),
  // Tag alert rules
  tagAlertRules: (pid) => Client.get(`projects/${pid}/tag-alert-rules/`),
  createTagAlertRule: (pid, body) => Client.post(`projects/${pid}/tag-alert-rules/`, body),
  patchTagAlertRule: (pid, rid, body) => Client.patch(`projects/${pid}/tag-alert-rules/${rid}/`, body),
  deleteTagAlertRule: (pid, rid) => Client.delete(`projects/${pid}/tag-alert-rules/${rid}/`),

  // MQTT gateway credentials (Máy B provision + mTLS)
  mqttCredentials: (pid) => Client.get(`projects/${pid}/mqtt-credentials/`),
  mqttProvision: (pid, body) => Client.post(`projects/${pid}/mqtt-credentials/provision/`, body || {}),
  mqttRevealPassword: (pid) => Client.post(`projects/${pid}/mqtt-credentials/reveal-password/`, {}),
  mqttCredentialBundle: (pid) =>
    Client.get(`projects/${pid}/mqtt-credentials/bundle/`, { responseType: "blob" }),
  mqttRotate: (pid) => Client.post(`projects/${pid}/mqtt-credentials/rotate/`, {}),
  mqttRevoke: (pid) => Client.post(`projects/${pid}/mqtt-credentials/revoke/`, {}),

  // Mimic layouts (F-53 — vẽ tĩnh; animation F-54 sau)
  mimicLayouts: (pid, params) => Client.get(`projects/${pid}/mimic-layouts/`, { params }),
  createMimicLayout: (pid, body) => Client.post(`projects/${pid}/mimic-layouts/`, body),
  mimicLayout: (pid, lid) => Client.get(`projects/${pid}/mimic-layouts/${lid}/`),
  patchMimicLayout: (pid, lid, body) => Client.patch(`projects/${pid}/mimic-layouts/${lid}/`, body),
  deleteMimicLayout: (pid, lid) => Client.delete(`projects/${pid}/mimic-layouts/${lid}/`)
}

export default ees
